import { pageToDataLayerInfo } from '../utils';
import { addToDataLayer, type DataLayerEvent } from '..';

export type ContentEventType = {
  id: string;
  link: string;
  type: string;
  action?: string;
  content?: string;
};

export function addSelectContentEventToDataLayer(data: ContentEventType) {
  const ga4Event: DataLayerEvent = {
    event: 'select_content',
    ecommerce: {
      content_id: data.id,
      content_link: data.link,
      content_type: data.type,
      content_action: data.action,
      copy_content: data.content,
      ...pageToDataLayerInfo(),
      items: [],
    },
  };
  addToDataLayer(ga4Event);
}
